/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import {Row} from "antd";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FIELD_META_PROP = "data-__meta";

var _react2 = _interopRequireDefault(React);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

class CkInfoItem extends React.Component {

    getControls=(children, recursively)=>{
        var controls = [];
        var childrenArray = _react2['default'].Children.toArray(children);
        for (var i = 0; i < childrenArray.length; i++) {
            if (!recursively && controls.length > 0) {
                break;
            }
            var child = childrenArray[i];
            if (!child.props) {
                continue;
            }
            if (FIELD_META_PROP in child.props) {
                controls.push(child);
            } else if (child.props.children) {
                controls = controls.concat(this.getControls(child.props.children, recursively));
            }
        }
        return controls;
    }

    getOnlyControl = () => {
        var child = this.getControls(this.props.children, false)[0];
        return child !== undefined ? child : null;
    }
    getChildProp = (prop) => {
        var child = this.getOnlyControl();
        return child && child.props && child.props[prop];
    }
    getId = () => {
        return this.getChildProp('id');
    }

    getHelpMsg = ()=>{
        var context = this.context;
        var props = this.props;
        if (props.help === undefined && context.form) {
            return this.getId() ? (context.form.getFieldError(this.getId()) || []).join(', ') : '';
        }
        return props.help;
    }


    render() {
        const help = this.getHelpMsg() ;
        const hasErrorHelp = help ? true : false;
        const errorComp = hasErrorHelp ? <div className="error-help">
            { help}
        </div> : null;

        var content =
            <div className={classNames({"ck-info-item-conten-indent": this.props.contentIndent, "has-error": hasErrorHelp})}>
                {this.props.children}
                {errorComp}
            </div>


        return (
            <div className="ck-info-item" style={Object.assign({width: "100%"},this.props.style)} >
                <div className="ck-info-item-label" style={this.props.labelStyle}>
                    <label className="mdc-text-grey " htmlFor="pane" >{this.props.label}</label>
                </div>
                <Row type="flex">
                    <div className="col-flex-primary ck-info-item-field" style={this.props.contentStyle}>
                        {content}
                    </div>
                </Row>
            </div>
        )
    }
}

CkInfoItem.contextTypes = {
    form: PropTypes.object
};


CkInfoItem.defaultProps = {
    label: "",
    help: undefined,
    labelStyle: {},
    contentStyle: {},
    //内容是否缩进
    contentIndent: true,
};

CkInfoItem.propTypes = {}


export default CkInfoItem;


// WEBPACK FOOTER //
// ./src/components/CkInfoItem.jsx